import { useAtomValue, useSetAtom } from "jotai";
import { isApprovalSendingAtom, sendForApprovalAtom } from "@/store/deduction/deduction";

export function useDeductionApproval() {
  const isApprovalSending = useAtomValue(isApprovalSendingAtom);
  const sendForApproval = useSetAtom(sendForApprovalAtom);

  return {
    isApprovalSending,
    sendForApproval,
  };
}